import { ReactNode } from "react";
import Icon from "../Icon";
import { ToggleButton } from "./ToggleButton";

import "../../styles/buttons/visibilityToggle.css";
import { ExpandingTooltipReturn } from "../hooks/useAdvancedTooltip";

export { VisibilityToggle };

type Props = {
  /**
   * class names
   */
  className?: string;
  /**
   * Controls how component is displayed.
   */
  active: boolean;
  onClick: () => void;
  /**
   * Text element to display within the button.
   */
  children: ReactNode;
  /**
   * Used to provide altText to the Icon. If nothing is used, the child text will be used as the alt text
   */
  altText?: string;
  tProps?: ExpandingTooltipReturn["triggerProps"];
};

/**
 *
 * @param props
 * @returns
 */
const VisibilityToggle = (props: Props) => {
  return (
    <ToggleButton
      className={`visibilityToggle ${props.active ? "active" : "inactive"} ${props.className ?? ""}`}
      active={props.active}
      onClick={props.onClick}
      tProps={props.tProps}
    >
      {props.children}
      <Icon
        icon={props.active ? "eye" : "eye-slash"}
        altText={
          props.altText ?? `${props.active ? "HIDE" : "SHOW"} ${props.children}`
        }
      />
    </ToggleButton>
  );
};
